import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageHeader1 from "../../components/common/PageHeader1";
import { getCMSPages, updateCmsApi } from "../../services/Cms";

function PrivacyPolicy() {
  const [editorValue, setEditorValue] = useState("");
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [cmsId, setCmsId] = useState(null);

  
  useEffect(() => {
    (async () => {
      try {
        const res = await getCMSPages("privacy-policy");
        if (res?.data) {
          const data = res.data;
          setEditorValue(data.content || "");
          setCmsId(data._id); // Required for update
        }
      } catch (error) {
        console.error("Failed to load CMS data:", error);
      }
    })();
  }, []);

  const onSubmit = async () => {
    if (!editorValue) {
      toast.error("Content is required");
      return;
    }

    const payload = {
      pageType: "privacy-policy",
      _id: cmsId, // Use cmsId for update
      content: editorValue,
    };
    console.log("Payload for update:", payload);
    try {
      const res = await updateCmsApi(payload);
      if (res?.success) {
        toast.success("Privacy Policy updated successfully");
      } else {
        toast.error("Failed to update Privacy Policy");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle="Edit Privacy Policy Page"
        navigation="CMS"
        // navlink="/cms"
        current="Privacy Policy"
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              {/* <h2>Edit Terms And Condition Page</h2> */}
            </div>

            <div className="col-md-12">
              <label className="form-label">Content</label>
              <ReactQuill
                theme="snow"
                value={editorValue}
                onChange={setEditorValue}
                placeholder="Enter content..."
              />
              {!editorValue && <p className="text-danger mt-1">Content is required</p>}
            </div>

            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5">
                Save Changes
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
